const toHex = (bytes: ArrayLike<number>): string =>
  Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');

export const generateNonce = (): string =>
  toHex(crypto.getRandomValues(new Uint8Array(32)));

export const sha256Hex = async (value: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(value)
  );
  return toHex(new Uint8Array(digest));
};
